import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_report_input_options_grid___ds_report_input_options_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { options: { label: string, value: string }[], $top?: number, $skip?: number }): Promise<{ result?: { label?: string, value?: string }[], totalCount?: number }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.options)) {
      $missingRequiredInParams.push('\'options\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { options?: { label: string, value: string }[], $keys: { label?: string, value?: string }[] }): Promise<{ result?: { label?: string, value?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      options: { label: string, value: string }[]    }) {
        if(isNil($inParams.options)) {
          return true; 
        }
      return false;
    }
}
